import { render } from "./ProductsApp.vue?vue&type=template&id=d033e1f4"
import script from "./ProductsApp.vue?vue&type=script&lang=js"
export * from "./ProductsApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/ProductsApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d033e1f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d033e1f4', __exports__)) {
    api.reload('d033e1f4', __exports__)
  }
  
  module.hot.accept("./ProductsApp.vue?vue&type=template&id=d033e1f4", () => {
    api.rerender('d033e1f4', render)
  })

}


export default __exports__